// Карточка билета с избранным, сравнением и окном подробностей
import { memo, type ReactNode } from 'react';
import type { Currency, Ticket } from '@sayohat/shared';
import { TicketCard, type PaxCount, type TicketLabel } from '../../entities/ticket';
import { toast } from '../../shared/ui/Toast';
import { toggleCompare, useIsCompared } from '../compare/model';
import { toggleFavorite, useIsFavorite } from '../favorites/model';
import { openTicket, type TicketContext } from './model';

export interface TicketItemProps {
  ticket: Ticket;
  currency: Currency;
  ctx: () => TicketContext;
  labels?: TicketLabel[];
  shift?: string;
  note?: ReactNode;
  pax?: PaxCount | null;
  /** после снятия звёздочки (избранное убирает карточку) */
  onFavChange?: (on: boolean) => void;
  /** id для избранного/сравнения, если в карточке показан обновлённый билет */
  favTicket?: Ticket;
}

function TicketItemView({ ticket, currency, ctx, labels, shift, note, pax, onFavChange, favTicket }: TicketItemProps) {
  const fav = useIsFavorite(ticket.id);
  const compared = useIsCompared(ticket.id);
  return (
    <TicketCard
      ticket={ticket}
      currency={currency}
      labels={labels}
      shift={shift}
      note={note}
      pax={pax}
      fav={fav}
      compared={compared}
      onCompare={() => { const c = ctx(); toggleCompare(ticket, { currency: c.currency, query: c.query }); }}
      onFav={() => {
        const c = ctx();
        const on = toggleFavorite(favTicket || ticket, { currency: c.currency, query: c.query });
        toast(on ? 'Добавлено в избранное' : 'Убрано из избранного');
        onFavChange?.(on);
      }}
      onOpen={() => openTicket(ticket, ctx())}
    />
  );
}

// Выдача перерисовывается при каждом обновлении (живые цены, фильтры) — карточки с теми же данными не перерисовываем.
// ctx и onFavChange — обработчики: читают актуальный поиск в момент нажатия, при сравнении не учитываются.
const labelsKey = (l?: TicketLabel[]) => (l ? l.map((x) => x.text).join('|') : '');
export const TicketItem = memo(TicketItemView, (a, b) => a.ticket === b.ticket && a.currency === b.currency && a.shift === b.shift
  && a.note === b.note && a.pax === b.pax && a.favTicket === b.favTicket && labelsKey(a.labels) === labelsKey(b.labels));
